export default __webpack_public_path__ + "static/media/home-repair.4433fc9d.svg";